(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casos-de-exito"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCases(root) {
      if (!root || root.dataset.casesInit) return;
      root.dataset.casesInit = 'true';
      var perPage = parseInt(root.dataset.perPage, 10) || 5;

      root.querySelectorAll('.cases-success__item').forEach(function (item) {
        var tabs = item.querySelectorAll('[data-tab]');
        function activate(active) {
          tabs.forEach(function (tab) {
            var on = tab === active;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            var panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
        }
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () { activate(tab); });
        });
        if (tabs.length) activate(tabs[0]);
      });

      var btn = root.querySelector('[data-load-more]');
      if (btn) {
        btn.addEventListener('click', function () {
          var hidden = root.querySelectorAll('.cases-success__item.is-hidden');
          for (var i = 0; i < Math.min(perPage, hidden.length); i++) {
            hidden[i].classList.remove('is-hidden');
          }
          if (hidden.length <= perPage) btn.parentElement.hidden = true;
        });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-cases-section]').forEach(initCases);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-cases-section]').forEach(initCases);
    });
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target.classList && e.target.classList.contains('cases-success__item')) {
        e.target.classList.remove('is-hidden');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
